import * as React from 'react';
import { UpgradeHelper,AdminToolHelper,IJourneyItem} from '../../../helpers';
import { Button } from 'office-ui-fabric-react';
import { AdminToolList } from '../../admintool/panels';

interface IProps {
    adminToolState: any;
    showStatus: boolean; 
    enableCancelButton?:boolean
}
export class ProcessUpgradePage extends React.Component<IProps, any> {
    componentDidMount() {
    }
    render() {

        let loggingListResults:any = this.props.adminToolState.loggingList.map((result: any, index: any) => {

            let className:string = AdminToolHelper.GetLogMessageStyle(result.upgradeMessageType);
            return (<li className={className}>{result.text}</li>);
        });

        let percent:number = ((this.props.adminToolState.journeyProcessNum + 1) / this.props.adminToolState.processList[this.props.adminToolState.tab].length) * 100;
        let style:any = {
            "width": percent +"%"
        };

        let getProcessingJourney:IJourneyItem = this.props.adminToolState.processList[this.props.adminToolState.tab].filter(a=>a.journeyId== this.props.adminToolState.journeyProcessingId)[0];
      
        let processHeader:string = getProcessingJourney && getProcessingJourney.journeyName + "(" +this.props.adminToolState.journeyProcessingId +") " + "." +
            (this.props.adminToolState.journeyProcessNum + 1 + "/" + this.props.adminToolState.processList[this.props.adminToolState.tab].length);

        let returnButtonLabel:any = "Return to "+ this.props.adminToolState.tab.toLowerCase() + " screen";
        return (
            <div>
                <div className="upgradepanel">
                    <h2>{this.props.adminToolState.tab} progress</h2>
                    {this.props.showStatus && <div>
                        {this.props.adminToolState.isProccessing ?
                            <div>
                                <h3>{processHeader}</h3>
                                <div className="pbar">
                                    <div style={{ width: percent + '%' }}></div>
                                </div>
                            </div> : null}
                    </div>}
                    <ul className="notes" id="notes">
                        {loggingListResults}
                    </ul>
                    <textarea id="loggingTextArea" style={{ position: 'absolute', 'top': '-74px' }}>
                    </textarea>
                    {this.props.enableCancelButton && <Button onClick={() => {
                        let feedbackAlert:boolean = confirm("Are you sure that you want to cancel?");
                        if (feedbackAlert) {
                            UpgradeHelper.SetCancelUpgrade(true);
                        }
                    }} disabled={this.props.adminToolState.cancelProcessAPICall || !this.props.adminToolState.isProccessing}>Cancel</Button>}
                    &nbsp;
                    <Button icon="Copy" onClick={() => {
                        AdminToolHelper.UpdateTextAreaLog(document.getElementById('notes').innerText);
                        AdminToolHelper.CopyToClipboard("loggingTextArea")
                    }}>Copy To Clipboard</Button>
                    &nbsp;
                    <Button disabled={(this.props.adminToolState.isProccessing ? true : false)} onClick={() => AdminToolHelper.ClearUpgradeState()}>{returnButtonLabel}</Button>
                </div>
                <AdminToolList panelTitle={"Journeys list"} adminToolState={this.props.adminToolState} enableRemoveButtons={false} panelName="processlist" showStatus={this.props.showStatus} />
            </div>
        );

    }
}


// WEBPACK FOOTER //
// ./source/ts/components/admintool/screens/processupgradepage.tsx